<template>
    <div class="oldCounterBoxContainer fontRoboto" v-if="visible">
        <div class="clearfix">
            <div class="whiteBox stdFirst">{{hours | firstDigit}}</div>
            <div class="whiteBox stdSecond">{{hours | secondDigit}}</div>
            <div class="whiteBox minFirst">{{minutes | firstDigit}}</div>
            <div class="whiteBox minSecond">{{minutes | secondDigit}}</div>
        </div>
        <div class="clearfix">
            <div class="stdMinTitle">STD.</div>
            <div class="stdMinTitle">MIN.</div>
        </div>
    </div>
</template>

<script>
   export default {
	   name: 'teaser-countdown',
	   mounted() {
		   window.setInterval(() => {
		       this.now = Math.trunc((new Date()).getTime());
	       },10000);
	   },
	   props: {
		   date: {
		      type: String,
		      required: true
		    }
	   },
	   data: function() {
	       return {
	    	   now: Math.trunc((new Date()).getTime())
	       }
	   },
	   computed: {
		   visible() {
			   if(this.hours.toString().length < 3) {
                   return true;
               }
			   return false;
		   },
		   minutes() {
			   var minutes = Math.trunc((this.date - this.now) / (60 * 1000)) % 60;
			   if(minutes < 0) {
				   return 0;
			   }
		       return minutes;
		   },
		   hours() {
		       return Math.trunc((this.date - this.now) / (60 * 60 * 1000));
		   }
	   },
	   filters: {
		   firstDigit: function (value) {
			   if(value < 10) {
				   return 0;
			   }
			   return value.toString().substring(0,1);
		   },
		   secondDigit: function (value) {
			   if(value < 10) {
                   return value.toString().substring(0,1);
			   }
			   return value.toString().substring(1,2);
           }
	   }
   }
</script>


// WEBPACK FOOTER //
// TeaserCountdown.vue?caf149c6